import { render, staticRenderFns } from "./Payroll.vue?vue&type=template&id=7e5009be&"
import script from "./Payroll.vue?vue&type=script&lang=ts&"
export * from "./Payroll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports